// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false
};

export const firebaseConfig = {
  apiKey: 'AIzaSyDIg9cIt8aML6kqG2v9YR4TZMl8Man5uLI',
  authDomain: 'betfight-acf73.firebaseapp.com',
  databaseURL: 'https://betfight-acf73.firebaseio.com',
  projectId: 'betfight-acf73',
  storageBucket: 'betfight-acf73.appspot.com',
  messagingSenderId: '428106832661',
  appId: '1:428106832661:web:243dd113f598a7b94e271c',
  measurementId: 'G-3SXGKGGCZ3',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
